export const iomoMaterials = {
	blackMatte: {
		id: 'blackMatte',
		label: {
			de: 'Black-matte',
			en: 'Black-matte',
			fr: 'Black-matte'
		},
		color: '#1f1f1f',
		material: {
			color: '#1f1f1f',
			emissive: '#000000',
			roughness: '0.56',
			metalness: '0.22',
			clearcoat: '0',
			clearcoatRoughness: '0',
			ior: '1.67',
			iridescence: '0',
			iridescenceIOR: '1.5',
			reflectivity: '0.14',
			sheen: '0',
			sheenRoughness: '1',
			sheenColor: '#000000',
			specularIntensity: '0.65',
			specularColor: '#000000',
			normalScale: 0,
			clearcoatNormalScale: 0
		}
	},
	blackSatin: {
		id: 'blackSatin',
		label: {
			de: 'Black-satin',
			en: 'Black-satin',
			fr: 'Black-satin'
		},
		color: '#171717',
		material: {
			color: '#171717',
			emissive: '#000000',
			roughness: '0.52',
			metalness: '0.22',
			clearcoat: '0',
			clearcoatRoughness: '0',
			ior: '1.67',
			iridescence: '0',
			iridescenceIOR: '1.5',
			reflectivity: '0.49',
			sheen: '0',
			sheenRoughness: '1',
			sheenColor: '#000000',
			specularIntensity: '0.65',
			specularColor: '#000000',
			normalScale: 0,
			clearcoatNormalScale: 0
		}
	},
	blackGloss: {
		id: 'blackGloss',
		label: {
			de: 'Black-Gloss',
			en: 'Black-Gloss',
			fr: 'Black-Gloss'
		},
		color: '#0d0d0d',
		material: {
			color: '#0d0d0d',
			emissive: '#000000',
			roughness: '0.22',
			metalness: '0',
			clearcoat: '0',
			clearcoatRoughness: '0',
			ior: '1.67',
			iridescence: '0',
			iridescenceIOR: '1.5',
			reflectivity: '0.14',
			sheen: '0',
			sheenRoughness: '1',
			sheenColor: '#000000',
			specularIntensity: '1',
			specularColor: '#ffffff',
			normalScale: 0,
			clearcoatNormalScale: 0
		}
	},
	brass: {
		id: 'brass',
		label: {
			de: 'Messing',
			en: 'Brass',
			fr: 'Brass'
		},
		color: '#878064',
		material: {
			color: '#878064',
			emissive: '#000000',
			roughness: '0.35',
			metalness: '0.21',
			clearcoat: '0',
			clearcoatRoughness: '0',
			ior: '1.67',
			iridescence: '0',
			iridescenceIOR: '1.5',
			reflectivity: '0.28',
			sheen: '0',
			sheenRoughness: '1',
			sheenColor: '#000000',
			specularIntensity: '0.82',
			specularColor: '#ffffff',
			normalScale: 0,
			clearcoatNormalScale: 0
		}
	},
	concrete: {
		id: 'concrete',
		label: {
			de: 'Beton',
			en: 'Concrete',
			fr: 'Concrete'
		},
		color: '#c1c2bd',
		material: {
			color: '#9B9B97',
			emissive: '#000000',
			roughness: '0.9',
			metalness: '0',
			clearcoat: '0',
			clearcoatRoughness: '0',
			ior: '1.67',
			iridescence: '0',
			iridescenceIOR: '1.5',
			reflectivity: '0.14',
			sheen: '0',
			sheenRoughness: '1',
			sheenColor: '#000000',
			specularIntensity: '0.65',
			specularColor: '#000000',
			normalScale: 0,
			clearcoatNormalScale: 0
		}
	},
	wineRed: {
		id: 'wineRed',
		label: {
			de: 'Weinrot',
			en: 'Wine Red',
			fr: 'Wine Red'
		},
		color: '#450815',
		material: {
			color: '#450815',
			emissive: '#000000',
			roughness: '0.22',
			metalness: '0',
			clearcoat: '0',
			clearcoatRoughness: '0',
			ior: '1.67',
			iridescence: '0',
			iridescenceIOR: '1.5',
			reflectivity: '0.14',
			sheen: '0',
			sheenRoughness: '1',
			sheenColor: '#000000',
			specularIntensity: '1',
			specularColor: '#ffffff',
			normalScale: 0,
			clearcoatNormalScale: 0
		}
	},
	graphite: {
		id: 'graphite',
		label: {
			de: 'Selux Graphit',
			en: 'Selux Graphite',
			fr: 'Selux Graphite'
		},
		color: '#4c4d4d',
		material: {
			color: '#4c4d4d',
			emissive: '#000000',
			roughness: '0.64',
			metalness: '0.52',
			clearcoat: '0.14',
			clearcoatRoughness: '0.49',
			ior: '1.67',
			iridescence: '0',
			iridescenceIOR: '1.5',
			reflectivity: '0.47',
			sheen: '0',
			sheenRoughness: '1',
			sheenColor: '#000000',
			specularIntensity: '0.65',
			specularColor: '#6c4247',
			normalScale: 2,
			clearcoatNormalScale: 0.1
		}
	},

	quartz: {
		id: 'quartz',
		label: {
			de: 'Siena',
			en: 'Siena',
			fr: 'Siena'
		},
		color: '#906b64',
		material: {
			color: '#7F615C',
			emissive: '#000000',
			roughness: '0.64',
			metalness: '0.26',
			clearcoat: '0.29',
			clearcoatRoughness: '0.6',
			ior: '1.67',
			iridescence: '0',
			iridescenceIOR: '1.5',
			reflectivity: '0.47',
			sheen: '0',
			sheenRoughness: '1',
			sheenColor: '#000000',
			specularIntensity: '0.72',
			specularColor: '#674C4F',
			normalScale: '2.22',
			clearcoatNormalScale: '2.57'
		}
	},
	saphireBlue: {
		id: 'saphireBlue',
		label: {
			de: 'Saphireblau',
			en: 'Saphire Blue',
			fr: 'Saphire Blue'
		},
		color: '#192334',
		material: {
			color: '#182334',
			emissive: '#000000',
			roughness: '0.22',
			metalness: '0',
			clearcoat: '0',
			clearcoatRoughness: '0',
			ior: '1.67',
			iridescence: '0',
			iridescenceIOR: '1.5',
			reflectivity: '0.41',
			sheen: '0',
			sheenRoughness: '1',
			sheenColor: '#000000',
			specularIntensity: '1',
			specularColor: '#4D74B3',
			normalScale: 0,
			clearcoatNormalScale: 0
		}
	},
	firGreen: {
		id: 'firGreen',
		label: {
			de: 'Tannengrün',
			en: 'Fir Green',
			fr: 'Fir Green'
		},
		color: '#151e15',
		material: {
			color: '#151e15',
			emissive: '#000000',
			roughness: '0.22',
			metalness: '0',
			clearcoat: '0',
			clearcoatRoughness: '0',
			ior: '1.67',
			iridescence: '0',
			iridescenceIOR: '1.5',
			reflectivity: '0.14',
			sheen: '0',
			sheenRoughness: '1',
			sheenColor: '#000000',
			specularIntensity: '1',
			specularColor: '#ffffff',
			normalScale: 0,
			clearcoatNormalScale: 0
		}
	},
	fern: {
		id: 'fern',
		label: {
			de: 'Farn',
			en: 'Fern',
			fr: 'Fern'
		},
		color: '#151e15',
		material: {
			color: '#494B34',
			emissive: '#000000',
			roughness: '0.41',
			metalness: '0.07',
			clearcoat: '0',
			clearcoatRoughness: '0',
			ior: '1.67',
			iridescence: '0',
			iridescenceIOR: '1.5',
			reflectivity: '0.47',
			sheen: '0',
			sheenRoughness: '1',
			sheenColor: '#000000',
			specularIntensity: '0.65',
			specularColor: '#31331E',
			normalScale: 0,
			clearcoatNormalScale: 0
		}
	},
	whiteAluminium: {
		id: 'whiteAluminium',
		label: {
			de: 'Weiß Aluminium',
			en: 'White Aluminium',
			fr: 'White Aluminium'
		},
		color: '#bfbdba',
		material: {
			color: '#bfbdba',
			emissive: '#000000',
			roughness: '0.4',
			metalness: '0.27',
			clearcoat: '0',
			clearcoatRoughness: '0',
			ior: '1.67',
			iridescence: '0',
			iridescenceIOR: '1.5',
			reflectivity: '0.47',
			sheen: '0',
			sheenRoughness: '1',
			sheenColor: '#000000',
			specularIntensity: '0.65',
			specularColor: '#31331e',
			normalScale: 0,
			clearcoatNormalScale: 0
		}
	},
	clay: {
		id: 'clay',
		label: {
			de: 'Ton',
			en: 'Clay',
			fr: 'Clay'
		},
		color: '#897e6c',
		material: {
			color: '#746958',
			emissive: '#000000',
			roughness: '0.52',
			metalness: '0.27',
			clearcoat: '0',
			clearcoatRoughness: '0',
			ior: '1.67',
			iridescence: '0',
			iridescenceIOR: '1.5',
			reflectivity: '0.34',
			sheen: '0',
			sheenRoughness: '1',
			sheenColor: '#000000',
			specularIntensity: '0.65',
			specularColor: '#000000',
			normalScale: 0,
			clearcoatNormalScale: 0
		}
	},
	terracotta: {
		id: 'terracotta',
		label: {
			de: 'Terracotta',
			en: 'Terracotta',
			fr: 'Terracotta'
		},
		color: '#452d21',
		material: {
			color: '#3E2D23',
			emissive: '#000000',
			roughness: '0.65',
			metalness: '0',
			clearcoat: '0.11',
			clearcoatRoughness: '0.52',
			ior: '1.67',
			iridescence: '0',
			iridescenceIOR: '1.5',
			reflectivity: '0.62',
			sheen: '0',
			sheenRoughness: '1',
			sheenColor: '#000000',
			specularIntensity: '0.37',
			specularColor: '#E19237',
			normalScale: '3.02',
			clearcoatNormalScale: '2.35'
		}
	},
	sand: {
		id: 'sand',
		label: {
			de: 'Sand',
			en: 'Sand',
			fr: 'Sand'
		},
		color: '#a39d8f',
		material: {
			color: '#888577',
			emissive: '#000000',
			roughness: '0.79',
			metalness: '0.09',
			clearcoat: '0',
			clearcoatRoughness: '0',
			ior: '1.67',
			iridescence: '0',
			iridescenceIOR: '1.5',
			reflectivity: '0.14',
			sheen: '0',
			sheenRoughness: '1',
			sheenColor: '#000000',
			specularIntensity: '0.65',
			specularColor: '#000000',
			normalScale: 0,
			clearcoatNormalScale: 0
		}
	}
};


export const iomoColorThemeOptions = {
	blackMatte: {
		id: 'blackMatte',
		label: {
			de: 'Selux Black-matte',
			en: 'Selux Black-matte',
			fr: 'Selux Black-matte',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.blackMatte,
			ring: iomoMaterials.blackMatte
		},
		swappable: false,
		swapped: false,
	},
	blackMatte_blackGloss: {
		id: 'blackMatte_blackGloss',
		label: {
			de: 'Selux black-matte · Selux black-gloss',
			en: 'Selux black-matte · Selux black-gloss',
			fr: 'Selux black-matte · Selux black-gloss',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.blackMatte,
			ring: iomoMaterials.blackGloss
		},
		swappable: true,
		swapped: false
	},

	concrete: {
		id: 'concrete',
		label: {
			de: 'Concrete',
			en: 'Concrete',
			fr: 'Concrete',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.concrete,
			ring: iomoMaterials.concrete
		},
		swappable: false,
		swapped: false
	},
	concrete_wineRed: {
		id: 'concrete_wineRed',
		label: {
			de: 'Concrete · Wine Red',
			en: 'Concrete · Wine Red',
			fr: 'Concrete · Wine Red',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.concrete,
			ring: iomoMaterials.wineRed
		},
		swappable: true,
		swapped: false
	},
	concrete_saphireBlue: {
		id: 'concrete_saphireBlue',
		label: {
			de: 'Concrete · Saphire Blue',
			en: 'Concrete · Saphire Blue',
			fr: 'Concrete · Saphire Blue',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.concrete,
			ring: iomoMaterials.saphireBlue
		},
		swappable: true,
		swapped: false
	},
	concrete_firGreen: {
		id: 'concrete_firGreen',
		label: {
			de: 'Concrete · Fir Green',
			en: 'Concrete · Fir Green',
			fr: 'Concrete · Fir Green',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.concrete,
			ring: iomoMaterials.firGreen
		},
		swappable: true,
		swapped: false
	},
	concrete_graphite: {
		id: 'concrete_graphite',
		label: {
			de: 'Concrete · Selux Graphite',
			en: 'Concrete · Selux Graphite',
			fr: 'Concrete · Selux Graphite',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.concrete,
			ring: iomoMaterials.graphite
		},
		swappable: true,
		swapped: false
	},
	concrete_blackMatte: {
		id: 'concrete_blackMatte',
		label: {
			de: 'Concrete · Selux black-matte',
			en: 'Concrete · Selux black-matte',
			fr: 'Concrete · Selux black-matte',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.concrete,
			ring: iomoMaterials.blackMatte
		},
		swappable: true,
		swapped: false
	},
	concrete_sand: {
		id: 'concrete_sand',
		label: {
			de: 'Concrete · Sand',
			en: 'Concrete · Sand',
			fr: 'Concrete · Sand',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.concrete,
			ring: iomoMaterials.sand
		},
		swappable: true,
		swapped: false
	},
	concrete_fern: {
		id: 'concrete_fern',
		label: {
			de: 'Concrete · Fern',
			en: 'Concrete · Fern',
			fr: 'Concrete · Fern',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.concrete,
			ring: iomoMaterials.fern
		},
		swappable: true,
		swapped: false
	},

	sand: {
		id: 'sand',
		label: {
			de: 'Sand',
			en: 'Sand',
			fr: 'Sand',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.sand,
			ring: iomoMaterials.sand
		},
		swappable: false,
		swapped: false
	},
	sand_graphite: {
		id: 'sand_graphite',
		label: {
			de: 'Sand · Selux Graphite',
			en: 'Sand · Selux Graphite',
			fr: 'Sand · Selux Graphite',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.sand,
			ring: iomoMaterials.graphite
		},
		swappable: true,
		swapped: false
	},
	sand_fern: {
		id: 'sand_fern',
		label: {
			de: 'Sand · Fern',
			en: 'Sand · Fern',
			fr: 'Sand · Fern',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.sand,
			ring: iomoMaterials.fern
		},
		swappable: true,
		swapped: false
	},
	sand_concrete: {
		id: 'sand_concrete',
		label: {
			de: 'Sand · Concrete',
			en: 'Sand · Concrete',
			fr: 'Sand · Concrete',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.sand,
			ring: iomoMaterials.concrete
		},
		swappable: true,
		swapped: false
	},
	sand_clay: {
		id: 'sand_clay',
		label: {
			de: 'Sand · Clay',
			en: 'Sand · Clay',
			fr: 'Sand · Clay',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.sand,
			ring: iomoMaterials.clay
		},
		swappable: true,
		swapped: false
	},
	sand_brass: {
		id: 'sand_brass',
		label: {
			de: 'Sand · Brass',
			en: 'Sand · Brass',
			fr: 'Sand · Brass',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.sand,
			ring: iomoMaterials.brass
		},
		swappable: true,
		swapped: false
	},
	sand_terracotta: {
		id: 'sand_terracotta',
		label: {
			de: 'Sand · Terracotta',
			en: 'Sand · Terracotta',
			fr: 'Sand · Terracotta',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.sand,
			ring: iomoMaterials.terracotta
		},
		swappable: true,
		swapped: false
	},
	sand_blackMatte: {
		id: 'sand_blackMatte',
		label: {
			de: 'Sand · Selux black-matte',
			en: 'Sand · Selux black-matte',
			fr: 'Sand · Selux black-matte',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.sand,
			ring: iomoMaterials.blackMatte
		},
		swappable: true,
		swapped: false
	},

	fern: {
		id: 'fern',
		label: {
			de: 'Fern',
			en: 'Fern',
			fr: 'Fern',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.fern,
			ring: iomoMaterials.fern
		},
		swappable: false,
		swapped: false
	},
	fern_concrete: {
		id: 'fern_concrete',
		label: {
			de: 'Fern · Concrete',
			en: 'Fern · Concrete',
			fr: 'Fern · Concrete',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.fern,
			ring: iomoMaterials.concrete
		},
		swappable: true,
		swapped: false
	},
	fern_firGreen: {
		id: 'fern_firGreen',
		label: {
			de: 'Fern · Fir Green',
			en: 'Fern · Fir Green',
			fr: 'Fern · Fir Green',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.fern,
			ring: iomoMaterials.firGreen
		},
		swappable: true,
		swapped: false
	},

	graphite: {
		id: 'graphite',
		label: {
			de: 'Selux Graphite',
			en: 'Selux Graphite',
			fr: 'Selux Graphite',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.graphite,
			ring: iomoMaterials.graphite
		},
		swappable: false,
		swapped: false
	},

	terracotta: {
		id: 'terracotta',
		label: {
			de: 'Terracotta',
			en: 'Terracotta',
			fr: 'Terracotta',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.terracotta,
			ring: iomoMaterials.terracotta
		},
		swappable: false,
		swapped: false
	},

	quartz: {
		id: 'quartz',
		label: {
			de: 'Quartz',
			en: 'Quartz',
			fr: 'Quartz',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.quartz,
			ring: iomoMaterials.quartz
		},
		swappable: false,
		swapped: false
	},

	clay: {
		id: 'clay',
		label: {
			de: 'Clay',
			en: 'Clay',
			fr: 'Clay',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.clay,
			ring: iomoMaterials.clay
		},
		swappable: false,
		swapped: false
	},

	quartz_wineRed: {
		id: 'quartz_wineRed',
		label: {
			de: 'Quartz · Wine Red',
			en: 'Quartz · Wine Red',
			fr: 'Quartz · Wine Red',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.quartz,
			ring: iomoMaterials.wineRed
		},
		swappable: true,
		swapped: false
	},
	quarz_saphireBlue: {
		id: 'quarz_saphireBlue',
		label: {
			de: 'Quartz · Saphire Blue',
			en: 'Quartz · Saphire Blue',
			fr: 'Quartz · Saphire Blue',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.quartz,
			ring: iomoMaterials.saphireBlue
		},
		swappable: true,
		swapped: false
	},
	quarz_firGreen: {
		id: 'quarz_firGreen',
		label: {
			de: 'Quartz · Fir Green',
			en: 'Quartz · Fir Green',
			fr: 'Quartz · Fir Green',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.quartz,
			ring: iomoMaterials.firGreen
		},
		swappable: true,
		swapped: false
	},
	quartz_terracotta: {
		id: 'quartz_terracotta',
		label: {
			de: 'Quartz · Terracotta',
			en: 'Quartz · Terracotta',
			fr: 'Quartz · Terracotta',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.quartz,
			ring: iomoMaterials.terracotta
		},
		swappable: true,
		swapped: false
	},

	clay_terracotta: {
		id: 'clay_terracotta',
		label: {
			de: 'Clay · Terracotta',
			en: 'Clay · Terracotta',
			fr: 'Clay · Terracotta',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.clay,
			ring: iomoMaterials.terracotta
		},
		swappable: true,
		swapped: false
	},
	clay_fern: {
		id: 'clay_fern',
		label: {
			de: 'Clay · Fern',
			en: 'Clay · Fern',
			fr: 'Clay · Fern',
		},
		description: {
			de: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			en: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
			fr: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
		},
		materials: {
			body: iomoMaterials.clay,
			ring: iomoMaterials.fern
		},
		swappable: true,
		swapped: false
	},
};


export const iomoColorEditionOptions = [
	{
		id: 'active',
		label: {
			de: 'Active',
			en: 'Active',
			fr: 'Active',
		},
		description: {
			de: 'Playful combinations, highlighting contrasting surfaces and colors that create lively spaces.',
			en: 'Playful combinations, highlighting contrasting surfaces and colors that create lively spaces.',
			fr: 'Playful combinations, highlighting contrasting surfaces and colors that create lively spaces.',
		},
		thumbnail: '/line-assets/img/iomo/iomo-active.png',
		colorThemes: [
			iomoColorThemeOptions.quartz_wineRed,
			iomoColorThemeOptions.concrete_wineRed,
			iomoColorThemeOptions.quarz_saphireBlue,
			iomoColorThemeOptions.concrete_saphireBlue,
			iomoColorThemeOptions.quarz_firGreen,
			iomoColorThemeOptions.concrete_firGreen,
		]
	},
	{
		id: 'purist',
		label: {
			de: 'Purist',
			en: 'Purist',
			fr: 'Purist',
		},
		description: {
			de: 'Crystalline combinations, reminiscent of concrete, metals, architectural essentials.',
			en: 'Crystalline combinations, reminiscent of concrete, metals, architectural essentials.',
			fr: 'Crystalline combinations, reminiscent of concrete, metals, architectural essentials.',
		},
		thumbnail: '/line-assets/img/iomo/iomo-purist.png',
		colorThemes: [
			iomoColorThemeOptions.graphite,
			iomoColorThemeOptions.blackMatte,
			iomoColorThemeOptions.concrete,
			iomoColorThemeOptions.sand,
			iomoColorThemeOptions.blackMatte_blackGloss,
			iomoColorThemeOptions.concrete_blackMatte,
			iomoColorThemeOptions.sand_graphite,
			iomoColorThemeOptions.concrete_graphite,
		]
	},
	{
		id: 'serene',
		label: {
			de: 'Serene',
			en: 'Serene',
			fr: 'Serene',
		},
		description: {
			de: 'Elegant combinations, bringing warmth and sophistication.',
			en: 'Elegant combinations, bringing warmth and sophistication.',
			fr: 'Elegant combinations, bringing warmth and sophistication.',
		},
		thumbnail: '/line-assets/img/iomo/iomo-serene.png',
		colorThemes: [

			iomoColorThemeOptions.quartz,
			iomoColorThemeOptions.sand,
			iomoColorThemeOptions.fern,
			iomoColorThemeOptions.concrete,
			iomoColorThemeOptions.concrete_sand,
			iomoColorThemeOptions.sand_clay,
			iomoColorThemeOptions.concrete_fern,
			iomoColorThemeOptions.sand_fern,
			iomoColorThemeOptions.sand_brass,
			iomoColorThemeOptions.sand_blackMatte,
		]
	},
	{
		id: 'natural',
		label: {
			de: 'Natural',
			en: 'Natural',
			fr: 'Natural',
		},
		description: {
			de: 'Earthy combinations, creating a feeling of natural groundedness.',
			en: 'Earthy combinations, creating a feeling of natural groundedness.',
			fr: 'Earthy combinations, creating a feeling of natural groundedness.',
		},
		thumbnail: '/line-assets/img/iomo/iomo-natural.png',
		colorThemes: [
			iomoColorThemeOptions.sand,
			iomoColorThemeOptions.fern,
			iomoColorThemeOptions.quartz,
			iomoColorThemeOptions.clay,
			iomoColorThemeOptions.terracotta,
			iomoColorThemeOptions.sand_terracotta,
			iomoColorThemeOptions.sand_fern,
			iomoColorThemeOptions.fern_firGreen,
			iomoColorThemeOptions.quartz_terracotta,
			iomoColorThemeOptions.clay_terracotta,
			iomoColorThemeOptions.clay_fern,
		]
	},
];
